// Utility function to reset the welcome dialog for testing
export function resetWelcomeDialog(): void {
  localStorage.removeItem('hasSeenWelcome');
  console.log('✅ Welcome dialog reset - it will show on next page load');
}

// Expose to window for console debugging
(window as any).resetWelcomeDialog = resetWelcomeDialog;